import { render } from "./ProductBestPrice.vue?vue&type=template&id=00072ce3"
import script from "./ProductBestPrice.vue?vue&type=script&lang=js"
export * from "./ProductBestPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__